import { KPI } from '../../../layout/KPI.jsx';
import { formatIQD } from '../../../shared/format.js';

// الـbackend يُرجع: { period, kpis: {...}, deltas }
// نحاول قراءة kpis أولاً، ثم نسقط على totals/today/الجذر للتوافق العكسي.
function pickRevenue(ov) {
  const t = ov?.kpis || ov?.totals || ov?.today || ov || {};
  return {
    total: t.totalRevenue ?? t.revenue ?? t.total ?? null,
    play: t.playRevenue ?? t.gateRevenue ?? t.gate ?? null,
    cafeteria: t.cafeteriaRevenue ?? t.cafeteria ?? null,
    toys: t.toysRevenue ?? t.toys ?? null,
    expenses: t.totalExpenses ?? t.expenses ?? null,
    net: t.netProfit ?? t.net ?? (
      (t.totalRevenue ?? t.revenue) != null && (t.totalExpenses ?? t.expenses) != null
        ? (t.totalRevenue ?? t.revenue) - (t.totalExpenses ?? t.expenses)
        : null
    ),
    visits: t.visitsCount ?? t.visits ?? t.totalVisits ?? null,
    pending: t.pendingInvoicesAmount ?? t.pending ?? t.pendingAmount ?? null
  };
}

const dash = '—';
const fmt = (v) => (v != null ? formatIQD(v) : dash);

export function OverviewKpis({ overview }) {
  const r = pickRevenue(overview);
  return (
    <div className="grid gap-3.5" style={{ gridTemplateColumns: 'repeat(4, minmax(0, 1fr))' }}>
      <KPI tone="orange" icon="finance" label="إجمالي الإيرادات" value={fmt(r.total)} />
      <KPI tone="cyan" icon="gate" label="إيراد اللعب" value={fmt(r.play)} />
      <KPI tone="yellow" icon="pos" label="إيراد الكافتيريا" value={fmt(r.cafeteria)} />
      <KPI tone="pink" icon="products" label="إيراد الألعاب" value={fmt(r.toys)} />
      <KPI tone="purple" icon="reports" label="المصاريف" value={fmt(r.expenses)} />
      <KPI tone="green" icon="pricing" label="صافي الربح" value={fmt(r.net)} />
      <KPI tone="cyan" icon="children" label="عدد الزيارات" value={r.visits != null ? r.visits : dash} />
      <KPI tone="orange" icon="checkout" label="فواتير معلّقة" value={fmt(r.pending)} />
    </div>
  );
}
